import React, { ElementType, forwardRef } from 'react';

import { Link as MUILink, LinkProps as MUILinkProps, useTheme } from '@mui/material';
import { useNavigate } from 'react-router';

export interface LinkProps extends MUILinkProps {
  component?: ElementType;
  target?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement> & React.MouseEventHandler<HTMLSpanElement>;
}

// MUI anchors and describes whichever element a Tooltip's ref reaches, so the ref has
// to land on the anchor for a reader focusing it to be told what the tooltip says.
const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, href, target, onClick, ...rest }, ref) => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
      <MUILink
        ref={ref}
        variant='inherit'
        color={theme.palette.info.main}
        onClick={e => {
          if (onClick) {
            onClick(e);
          }
          if (!e.metaKey && href && !(href.startsWith('http://') || href.startsWith('https://'))) {
            e.preventDefault();
            e.stopPropagation();
            if (target) {
              window.open(`${window.location.origin}${href}`, target);
            } else {
              navigate(href);
            }
          }
        }}
        target={target}
        href={href}
        {...rest}
      >
        {children}
      </MUILink>
    );
  }
);

Link.displayName = 'Link';

export default Link;
